import { render } from "./upload_single_drag.vue?vue&type=template&id=7d645db5&scoped=true"
import script from "./upload_single_drag.vue?vue&type=script&lang=js"
export * from "./upload_single_drag.vue?vue&type=script&lang=js"

import "./upload_single_drag.vue?vue&type=style&index=0&id=7d645db5&scoped=true&lang=css"
import "./upload_single_drag.vue?vue&type=style&index=1&id=7d645db5&lang=css"

import exportComponent from "E:\\devops.aliyun\\deyi\\baobei_web2\\web2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d645db5"]])

export default __exports__